// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button.is-plain[data-v-40a63a44]{--el-button-active-text-color:var(--el-color-primary);--el-button-active-border-color:var(--el-color-primary)}.el-button--primary.is-plain[data-v-40a63a44]{--el-button-border-color:var(--el-color-primary-light-3)}.el-link.el-link--primary[data-v-40a63a44]:hover{color:var(--el-color-primary-light-3)}.tree-box[data-v-40a63a44]{overflow:auto}.tree-box[data-v-40a63a44],.tree-box[data-v-40a63a44] .el-tree__empty-block{height:300px}", ""]);
// Exports
module.exports = exports;
